export function DatetimeData() {
    return {
        name: "datetime",
        label: "Datetime",
        primitiveType: "string",
    };
}

export default DatetimeData;
